<template>
  <!-- Dialog for displaying label options -->
  <v-dialog v-model="showDialog" max-width="500">
    <v-card>
      <v-card-title>Label Options</v-card-title>
      <v-card-text>
        <!-- Drop-down for selecting label type -->
        <v-select
          v-model="labelType"
          :items="labelTypes"
          label="Select Label Type"
          outlined
        ></v-select>
              <v-select
                v-model="labelRotate"
                :items="['auto', '0', '90']"
                label=""
                outlined
                dense
              ></v-select>

        <v-img
          :src="labelUrl"
          alt="Label Preview"
          contain
          loading="imageLoading"
          max-height="300"
        ></v-img>

        <v-overlay :value="showLoadingIndicator">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-overlay>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="grey darken-1"
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="blue darken-1"
          @click="saveLabel"
        >
          Save
        </v-btn>
        <v-btn
          text
          color="green darken-1"
          @click="printLabel"
          :disabled="!isPrintServerHealthy"
        >
          Print
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  props: {
    item: Number,
    showDialog: { Boolean, required: true },
  },
  data() {
    return {
      labelUrl: null,
      labelItem: null,
      labelType: '62x44-1',
      labelRotate: 'auto',
      imageLoading: false,
      labelTypes: [],
      localShowDialog: this.showDialog,
      isPrintServerHealthy: false,
      showLoadingIndicator: false
    };
  },
  watch: {
    showDialog(newVal) {
      this.localShowDialog = newVal;
      if (newVal) this.fetchLabel();
    },
    item() {
      this.fetchLabel();
    },
    localShowDialog(newVal) {
      if (!newVal) {
        this.$emit('close');
      }
    },
    labelType() {
      this.fetchLabel(); // Fetch new label when labelType changes
    }
  },
  async mounted() {
    // Fetch labelTypes
    const resp = await this.$api.get('/repairs/labels/service-label-types');
    this.labelTypes = resp.data;
  },
  methods: {
    generateFilename(item) {
      return `Service-ID${item}.png`;
    },
    async fetchLabel() {
      const options = {
        method: 'GET',
        params: { label: this.labelType, filetype: "png" },
        url: '/repairs/labels/generate-service-label/' + this.item,
        responseType: "blob",
      };

      try {
        this.imageLoading = true;
        this.showLoadingIndicator = true;
        this.labelItem = this.item;
        this.showDialog = true;
        const response = await this.$api(options);
        this.labelUrl = window.URL.createObjectURL(response.data);
        await this.checkPrintServerHealth();
      } catch (error) {
        this.$emit('show-snackbar', { message: 'Failed to fetch label', color: 'error' });
        this.labelItem = null;
      } finally {
        this.showLoadingIndicator = false;
      }
    },
    cancel() {
      this.localShowDialog = false;
      window.URL.revokeObjectURL(this.labelUrl);
      this.labelItem = null;
      this.$emit('close');
    },
    saveLabel() {
      const a = document.createElement('a');
      a.href = this.labelUrl;
      a.download = this.generateFilename(this.labelItem);
      a.click();
      a.remove();
      this.cancel();
    },
    async printLabel() {
      try {
        this.showLoadingIndicator = true;
        const response = await fetch(this.labelUrl);
        const blob = await response.blob();
        const formData = new FormData();
        formData.append('image', blob, this.generateFilename(this.labelItem));

        await this.$printerapi.post('/print', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          params: {
            rotate: this.labelRotate,
            red: true,
          },
        });

        this.cancel();
      } catch (error) {
        this.$emit('show-snackbar', { message: 'Failed to print label', color: 'error' });
      } finally {
        this.showLoadingIndicator = false;
      }
    },
    async checkPrintServerHealth() {
      try {
        const response = await this.$printerapi.get('/health', { crossDomain: true });
        this.isPrintServerHealthy = response.status === 200;
      } catch (error) {
        this.$emit('show-snackbar', { message: 'Print server health check failed', color: 'error' });
        this.isPrintServerHealthy = false;
      }
    }
  }
};
</script>